import { Input } from "@babackapp/ui/components/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { forwardRef } from "react";
import FormInputContainer from "./form-input-container";

type FormInputWithSelectSuffixProps = {
  label: string;
  description?: string;
  disabled?: boolean | string;
  error?: string;
  value: {
    input: string;
    select: string;
  };
  onChange: (value: { input: string; select: string }) => void;
  options: string[];
  separator?: string;
};

export default forwardRef(function FormInputWithSelectSuffix(
  {
    label,
    description,
    disabled,
    value,
    onChange,
    options,
    error,
    separator,
  }: FormInputWithSelectSuffixProps,
  ref: React.Ref<HTMLInputElement>,
) {
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ input: e.target.value, select: value.select });
  };

  const onOptionChange = (select: string) => {
    onChange({ input: value.input, select });
  };

  return (
    <FormInputContainer
      disabled={disabled}
      label={label}
      description={description}
      disabledMessage
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center flex-1">
          <div className="relative flex-1">
            <Input
              ref={ref}
              value={value.input}
              onChange={onInputChange}
              disabled={!!disabled}
              className={
                separator
                  ? "rounded-r-none pr-6 w-full"
                  : "rounded-r-none w-full"
              }
            />
            {separator && (
              <span className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none select-none">
                {separator}
              </span>
            )}
          </div>
          <div className="inline">
            <Select onValueChange={onOptionChange} value={value.select}>
              <SelectTrigger className="rounded-l-none border-l-none text-muted-foreground h-10">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {options.map((option) => (
                  <SelectItem
                    key={option}
                    value={option}
                    onClick={() =>
                      onChange({ input: value.input, select: option })
                    }
                  >
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        {error && <span className="text-sm text-destructive">{error}</span>}
      </div>
    </FormInputContainer>
  );
});
